import { useCallback, useEffect, useState } from 'react';
import { DIST026_TREATMENT_KEY, DIST026_GROUP_PARAMETER_KEY, PARAMETERS, DIST026_STATUS_PARAMETER_KEY, DIST026_IS_ACTIVE_KEY, DIST026_GROUP_PARAMETER_OPTIONS } from '../constants/experimentKeys';
import { fetchHsfxEligibility } from '../api/dist026Api';
import { inDist026Cohort } from '../utils/dist026Utils';
import { laboratoryClient, logExposure } from '../utils/laboratoryClient';

// DIST026
export const useDist026Group = () => {
  const [dist026Group, setDist026Group] = useState();
  const [experimentActive, setExperimentActive] = useState();
  const [treatmentFetched, setTreatmentFetched] = useState();
  const excludeUserFromExperiment = useCallback(() => {
    setDist026Group(DIST026_GROUP_PARAMETER_OPTIONS.control);
    setExperimentActive(false);
    setTreatmentFetched(true);
  }, []);
  useEffect(() => {
    fetchHsfxEligibility().then(eligibility => {
      if (inDist026Cohort(eligibility)) {
        laboratoryClient.resolve(treatments => {
          if (Object.keys(treatments).length) {
            const treatment = treatments[DIST026_TREATMENT_KEY];
            const optionValue = treatment[PARAMETERS][DIST026_GROUP_PARAMETER_KEY];
            const isActive = treatment[DIST026_STATUS_PARAMETER_KEY][DIST026_IS_ACTIVE_KEY];
            setDist026Group(optionValue);
            setExperimentActive(isActive);
            setTreatmentFetched(true);
            logExposure(DIST026_TREATMENT_KEY);
          }
        });
      } else {
        excludeUserFromExperiment();
      }
    }).catch(() => {
      excludeUserFromExperiment();
    });
  }, [excludeUserFromExperiment]);
  return {
    dist026Group,
    dist026Active: experimentActive,
    dist026TreatmentFetched: treatmentFetched
  };
};